module.exports = __webpack_public_path__ + "static/media/aguardandoLocalizacaoMobile.bfe38c11.jpg";